export const environment = {
  production: true,
  apiUrl: 'https://supdc.studentscenter.in/api',
  uploadFile : 'https://supdc.studentscenter.in/api/markListUploadUrl',
  PaymentIssueUrl:'https://supdc.studentscenter.in/api/PaymentIssueUrl',
  courier_excel_sheets: 'https://supdc.studentscenter.in/api/courier_excel_sheets',
  Damageceritificate:'https://supdc.studentscenter.in/api/Damageceritificate',
  viewUrl: 'https://supdc.studentscenter.in/api/',
  uploadFiles: 'https://supdc.studentscenter.in/api/adminupload',
  adminnewupload:'https://supdc.studentscenter.in/api/adminnewupload',
  emailIdOperational : 'su.sfc@studentscenter.in',
  numberOperational : '9702301302',
  imageUrl : "https://supdc.studentscenter.in",

  testUser: {
    token: {},
    email: '',
  },
};
